<template>
    <div>

        <div class="d-flex mb-3">
            <div>
                <label class="form-label">{{ textType }} Font</label>
                <select class="form-select" aria-label="Select header font" v-model="font.family"
                        @change="onFontSelected">
                    <option v-for="font in model.fonts" :value="font.family">{{ font.family }}</option>
                </select>
            </div>

            <div class="ms-1">
                <label class="form-label">Weight</label>
                <select class="form-select" aria-label="Select header font weight" v-model="font.weight">
                    <option v-for="fontWeight in availableWeights" :value="fontWeight">{{ fontWeight }}</option>
                </select>
            </div>
        </div>

    </div>
</template>

<script>

export default {
    name: 'FontStyleEditor',
    props: ['font', 'textType'],
    data() {
        return {
            model: webase.model
        }
    },
    mounted() {
        this.injectFont()
    },
    computed: {
        availableWeights() {
            return webase.utils.ui.availableWeights(this.model.fonts, this.font.family)
        }
    },
    methods: {
        onFontSelected() {
            this.injectFont()
            this.resetWeight()
        },
        injectFont() {
            let weights = this.availableWeights.join(';')
            weights = weights.replace('regular', '400')
            webase.utils.ui.injectFont(this.font.family, ':wght@' + weights)
        },
        resetWeight() {
            this.font.weight = 'regular'
        }
    }
}
</script>
